// 动态表格配置列数据

import { formatMoney,formatPercent } from "@/utils/tools";

// PM零售负责人列配置
export const pmRetailColumns = [
  // 序号应该放在第一列才能生效
  { label: "序号", type: "index", width: 60, fixed: "left" },
  {
    label: "基础信息",
     fixed: "left",
     width:770,
    //  一级表头的 width 决定了 fixed 区域的宽度

    children: [
      { prop: "dept", label: "一级部门", width: 120 ,fixed: "left"},
      { prop: "position", label: "岗位", width: 120,fixed: "left" },
      { prop: "rank", label: "职级", width: 100 ,fixed: "left"},
      { prop: "name", label: "姓名", width: 100 ,fixed: "left"},
      { prop: "empno", label: "工号", width: 100,fixed: "left" },
      { prop: "channel", label: "渠道", width: 120 ,fixed: "left"},
      { prop: "month", label: "提成月份数", width: 110 },
    ],
  },
  {
    label: "销售业绩",
    align: "center",
    children: [
      { prop: "volume", label: "目标销量", minWidth: 120, formatter: formatMoney},
      { prop: "realfinish", label: "实际完成", minWidth: 120, formatter: formatMoney },
    ],
  },
  {
    label: "考核指标",
    align: "center",
    children: [
      { prop: "kpiscore", label: "KPI得分", minWidth: 100 },
      {
        prop: "royaltyrate",
        label: "岗位提成率",
        minWidth: 140,
        formatter: formatPercent,
      },
      {
        prop: "ngm",
        label: "目标净毛利率",
        minWidth: 140,
        formatter: formatPercent,
      },
      {
        prop: "realngm",
        label: "实际毛利率",
        minWidth: 120,
        formatter: formatPercent,
      },
      {
        prop: "achievingrate",
        label: "净毛利率达成系数",
        minWidth: 140,
      },
      { prop: "adjust", label: "调节系数", minWidth: 110 },
    ],
  },
  {
    prop: "wage",
    label: "提成工资",
    minWidth: 120,
    formatter: formatMoney,
  },
  {
    prop: "payable1",
    label: "应发(80%)",
    minWidth: 110,
    formatter: formatMoney,
  },
  {
    prop: "unpaid",
    label: "剩余未发(20%)",
    minWidth: 130,
    formatter: formatMoney,

  },
  {
    prop: "reissue",
    label: "补发",
    minWidth: 100,
    formatter: formatMoney,

  },
  {
    prop: "deduction",
    label: "扣减",
    minWidth: 100,
    formatter: formatMoney,

  },
  {
    prop: "payable2",
    label: "应发",
    minWidth: 100,
    formatter: formatMoney,

  },
  {
    prop: "remark",
    label: "备注",
    width: 100,
  },
];

// "status","状态：1：待确认；2：待审批；3：驳回；4：通过"
// 支持部门长列配置
export const supportDeptColumns = [
  { label: "序号", type: "index", width: 60,fixed: "left"  },
  { prop: "dept", label: "一级部门", minWidth: 120,fixed: "left" },
  { prop: "position", label: "岗位", minWidth: 120 ,fixed: "left"},
  { prop: "rank", label: "职级", minWidth: 100 ,fixed: "left"},
  { prop: "name", label: "姓名", minWidth: 100 ,fixed: "left"},
  { prop: "empno", label: "工号", minWidth: 100,fixed: "left" },
  { prop: "channel", label: "渠道", minWidth: 120,fixed: "left" },
  { prop: "score", label: "考核得分", minWidth: 80 },
  {
    prop: "wagestandard",
    label: "月度绩效工资标准",
    minWidth: 140,
    formatter: formatMoney,
  },
  { prop: "month", label: "核算绩效月份数", minWidth: 140 },
  {
    prop: "ebitda_coefficient",
    label: "EBITDA达成率系数",
    minWidth: 120,
    // formatter: formatPercent,
  },
  { prop: "adjust", label: "调节系数", minWidth: 100 },
  {
    prop: "qkpi",
    label: "绩效",
    minWidth: 100,
    formatter: formatMoney,
  },
  {
    prop: "payable1",
    label: "应发(80%)",
    minWidth: 110,
    formatter: formatMoney,
  },
  {
    prop: "unpaid",
    label: "剩余未发(20%)",
    minWidth: 130,
    formatter: formatMoney,
  },
    {
    prop: "reissue",
    label: "补发",
    minWidth: 100,
    formatter: formatMoney,
  },
  {
    prop: "deduction",
    label: "扣减",
    minWidth: 100,
    formatter: formatMoney,
  },
  {
    prop: "payable2",
    label: "应发",
    minWidth: 100,
    formatter: formatMoney,
  },
  { prop: "remark", label: "备注", minWidth: 100 },
];

// 运营提成列配置
export const operationColumns = [
  { label: "序号", type: "index", width: 60, fixed: "left" },
  {
    label: "基础信息",
    align: "center",
    fixed: "left",
    width:560,
    children: [
      { prop: "dept", label: "一级部门", width: 120 ,fixed: "left"},
      { prop: "name", label: "姓名", width: 100,fixed: "left" },
      { prop: "empno", label: "工号", width: 100,fixed: "left" },
      { prop: "channel", label: "渠道", width: 120,fixed: "left" },
      { prop: "month", label: "提成月份数", width: 120 },
    ],
  },
  {
    label: "销售业绩",
    align: "center",
    minWidth: 260,
    children: [
      {
        prop: "volume",
        label: "目标销量",
        minWidth: 120,
        formatter: formatMoney,
      },
      {
        prop: "realfinish",
        label: "实际完成",
        minWidth: 120,
        formatter: formatMoney,
      },
    ],
  },
  {
    label: "考核指标",
    align: "center",
    children: [
      { prop: "kpiscore", label: "KPI得分", minWidth: 80 },
      {
        prop: "royaltyrate",
        label: "岗位提成率",
        minWidth: 100,
        formatter: formatPercent,
      },
      {
        prop: "ngm",
        label: "目标毛利率",
        minWidth: 100,
        formatter: formatPercent,
      },
      {
        prop: "realngm",
        label: "实际毛利率",
        minWidth: 100,
        formatter: formatPercent,
      },
      { prop: "achievingrate", label: "毛利率达成系数", minWidth: 120 },
      { prop: "adjust", label: "调节系数", minWidth: 80 },
    ],
  },
  {
    prop: "wage",
    label: "提成工资",
    minWidth: 100,
    formatter: formatMoney,
  },
  {
    prop: "payable1",
    label: "应发(80%)",
    minWidth: 90,
    formatter: formatMoney,
  },
  {
    prop: "unpaid",
    label: "剩余未发(20%)",
    minWidth: 120,
    formatter: formatMoney,
  },
    {
    prop: "reissue",
    label: "补发",
    minWidth: 100,
    formatter: formatMoney,
  },
  {
    prop: "deduction",
    label: "扣减",
    minWidth: 100,
    formatter: formatMoney,
  },
  {
    prop: "payable2",
    label: "应发",
    minWidth: 100,
    formatter: formatMoney,
  },
  {
    prop: "remark",
    label: "备注(转岗/晋升/产假/病假/特殊情况)",
    minWidth: 150,
  },
];

// 后端绩效列配置
export const backendColumns = [
  { label: "序号", type: "index", width: 60, fixed: "left" },

  {
    label: "基础信息",
    align: "center",
    fixed:'left',
    width:640,
    children: [
      { prop: "dept", label: "一级部门", width: 120 },
      { prop: "position", label: "岗位", width: 100 },
      { prop: "rank", label: "职级", width: 100 },
      // { prop: "rankgrade", label: "职级&等级", width: 90 },
      { prop: "name", label: "姓名", width: 100 },
      { prop: "empno", label: "工号", width: 100 },
      { prop: "channel", label: "渠道", width: 120 },
    ],
  },
  {
    prop: "realmonth",
    label: "绩效实际月份数",
    minWidth: 100,
    align: "center",
  },
  {
    prop: "grade",
    label: "绩效等级",
    minWidth: 80,
    align: "center",
  },
  {
    prop: "kpistandard",
    label: "绩效奖金标准",
    minWidth: 110,
    align: "center",
    formatter: formatMoney,
  },
  {
    prop: "ebitda_coefficient",
    label: "EBITDA达成率系数",
    minWidth: 120,
    align: "center",
  },
  {
    prop: "adjust",
    label: "调节系数",
    minWidth: 90,
    align: "center",
  },
  {
    prop: "qkpi",
    label: "绩效",
    minWidth: 100,
    align: "center",
    formatter: formatMoney,
  },
  {
    prop: "payable1",
    label: "应发(80%)",
    minWidth: 100,
    align: "center",
    formatter: formatMoney,
  },
  {
    prop: "unpaid",
    label: "剩余未发(20%)",
    minWidth: 120,
    align: "center",
    formatter: formatMoney,
  },
    {
    prop: "reissue",
    label: "补发",
    minWidth: 100,
    formatter: formatMoney,
  },
  {
    prop: "deduction",
    label: "扣减",
    minWidth: 100,
    formatter: formatMoney,
  },
  {
    prop: "payable2",
    label: "应发",
    minWidth: 100,
    align: "center",
    formatter: formatMoney,
  },
  {
    prop: "remark",
    label: "备注",
    minWidth: 100,
    align: "center",
  },
];
